import {Space} from 'antd'

import './UserItem.scss'
import {Text, UserAvatar} from 'common/components'

interface UserItemProps {
  showDisplayId?: boolean
  user: any
}

export default function UserItem({showDisplayId = true, user}: UserItemProps) {
  return (
    <div className="UserItem">
      <Space>
        <UserAvatar size={24} src={user.photo} alt={user.name || user.firstName} />
        <span>
          { user?.name || `${user.firstName} ${user.lastName}`}
        </span>
      </Space>
      {showDisplayId && user.displayId && (
        <Text color="grey" size="xs" ml={12}>
          {user.displayId}
        </Text>
      )}
    </div>
  )
}
